import {useEffect, useState} from "react"
import "./index.scss"

const FampeModal = ({
                     show,
                     title,
                     children,
                     callBackClose,
                     square = false,
                   }) => {
  const [showModal, setShowModal] = useState(show)
  const [shouldRender, setShouldRender] = useState(show)

  const closeModal = () => {
    setShowModal(false)
    const timer = setTimeout(() => {
      setShouldRender(false)
      if (callBackClose) callBackClose()
    }, 200)

    return () => clearTimeout(timer)
  }

  useEffect(() => {
    if (show) {
      setShouldRender(true)
      setTimeout(() => {
        setShowModal(true)
      }, 10)
    } else {
      closeModal()
    }
    // eslint-disable-next-line
  }, [show])

  useEffect(() => {
    showModal
      ? (document.body.style.overflow = "hidden")
      : (document.body.style.overflow = "")
  }, [showModal])

  if (!shouldRender) return null

  return (
    <div className={"fampe-modal " + (showModal ? "open" : "")}>
      <div onClick={() => closeModal()} className="close-page"></div>
      <div className="wrapper-modal">
        <button className="btn-close" onClick={() => closeModal()}>
          <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
            <path d="M10.616 9.49982L14.0201 6.10357C14.3306 5.79314 14.3306 5.28983 14.0201 4.9794C13.7097 4.66897 13.2064 4.66897 12.896 4.9794L9.49971 8.38357L6.10346 4.9794C5.79303 4.66897 5.28972 4.66897 4.97929 4.9794C4.66886 5.28983 4.66886 5.79314 4.97929 6.10357L8.38346 9.49982L4.97929 12.8961C4.82942 13.0447 4.74512 13.2471 4.74512 13.4582C4.74512 13.6692 4.82942 13.8716 4.97929 14.0202C5.12794 14.1701 5.33029 14.2544 5.54137 14.2544C5.75246 14.2544 5.95481 14.1701 6.10346 14.0202L9.49971 10.6161L12.896 14.0202C13.0446 14.1701 13.247 14.2544 13.458 14.2544C13.6691 14.2544 13.8715 14.1701 14.0201 14.0202C14.17 13.8716 14.2543 13.6692 14.2543 13.4582C14.2543 13.2471 14.17 13.0447 14.0201 12.8961L10.616 9.49982Z" fill="#005EB8"/>
          </svg>
        </button>
        <div className="content">
          {title && (
            <div className="modal-header">
              <h3 className={`title ${square ? "square-title" : ""} `}>
                {title}
              </h3>
            </div>
          )}
          {children}
        </div>
      </div>
    </div>
  )
}

export default FampeModal
